import React, { useState, useEffect } from 'react';
import 'lightbox.js-react/dist/index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import APICall from './Api';
import Preloader from './common/Loaders/Preloader';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import Table from 'react-bootstrap/Table';
import 'boxicons/css/boxicons.min.css';
import moment from 'moment';
import { CSVLink } from 'react-csv';

function AllBookingPage() {
  const [loading, setLoading] = useState(false);
  const [allBooking, setAllBooking] = useState([]);
  const [csvData, setCSVData] = useState([]);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const [show, setShow] = useState(false);
  const [refreshInterval, setRefreshInterval] = useState(null);

  const [showDelete, setShowDelete] = useState({ status: false });

  const handleClose = () => {
    setUsername('');
    setPassword('');
    setShow(false);
    checkAuthentication();
  };

  const handleCloseDelete = () => {
    setShowDelete({ status: false });
    checkAuthentication();
  };

  useEffect(() => {
    if (refreshInterval === null) {
      setRefresh();
    }
    checkAuthentication();

    return () => {
      if (refreshInterval !== null) {
        clearInterval(refreshInterval);
      }
    };
  }, []);

  const checkAuthentication = () => {
    let username = sessionStorage.getItem('username');
    let password = sessionStorage.getItem('password');
    if (!username || !password) {
      return setShow(true);
    } else {
      fetchBooking();
    }
  };

  const setRefresh = () => {
    if (refreshInterval !== null) {
      return;
    }
    let inter = setInterval(() => {
      fetchBooking();
    }, 10000);

    if (inter > 1) {
      clearInterval(inter);
    } else {
      setRefreshInterval(inter);
    }
  };

  const fetchBooking = () => {
    let username = sessionStorage.getItem('username');
    let password = sessionStorage.getItem('password');
    if (!username || !password) {
      return;
    }
    setLoading(true);
    setAllBooking([]);
    APICall.fetchAllBooking().then((response) => {
      setLoading(false);
      if (response.success) {
        let d = [['ID', 'Stall Numbers', 'Company Name', 'Contact Person Name', 'Contact Number', 'Booked At']];
        response.data.map((booking) => {
          d.push([
            booking._id,
            booking.stalls.join(', '),
            booking.company,
            booking.contact_person_name,
            booking.contact_person_number,
            moment(booking.createdAt).format('DD MMM YYYY, hh:MM A'),
          ]);
        });
        setCSVData(d);
        setAllBooking(response.data);
      } else {
        setAllBooking([]);
        checkAuthentication();
      }
    });
  };

  const saveAuth = () => {
    if (username.trim().length === 0) {
      toast.error('Username is required', { hideProgressBar: true });
      return;
    }
    if (password.trim().length === 0) {
      toast.error('Password is required', { hideProgressBar: true });
      return;
    }

    sessionStorage.setItem('username', btoa(username));
    sessionStorage.setItem('password', btoa(password));
    handleClose();
    fetchBooking();
  };

  function logout() {
    sessionStorage.removeItem('username');
    sessionStorage.removeItem('password');
    checkAuthentication();
  }

  function deleteBooking() {
    handleCloseDelete();
    setLoading(true);
    APICall.deleteBooking({
      id: showDelete.data,
    })
      .then((response) => {
        setLoading(false);
        if (response.success) {
          toast.success('Booking Deleted Successfully', { hideProgressBar: true });
        } else {
          toast.error('Failed to Delete Booking', { hideProgressBar: true });
        }
      })
      .finally(() => {
        fetchBooking();
      });
  }

  return (
    <div className='row w-100 p-1 ms-1'>
      {!show && (
        <div className='row'>
          <div className='col-12 col-lg-12'>
            <div className='mx-auto'>
              <div className='row mb-3 d-flex justify-content-end gap-2'>
                <CSVLink data={csvData} style={{ width: 'fit-content' }}>
                  <button className='btn btn-success' style={{ width: '150px' }}>
                    Export
                  </button>
                </CSVLink>
                <button className='btn btn-danger' style={{ width: '150px' }} onClick={() => logout()}>
                  Logout
                </button>
              </div>
              <Table striped bordered hover className='w-100'>
                <thead>
                  <tr>
                    <th>Stalls</th>
                    <th>Company Name</th>
                    <th>Contact Person Name</th>
                    <th>Contact Number</th>
                    <th>Booked At</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {allBooking.map((booking) => {
                    return (
                      <tr>
                        <td>{booking.stalls.join(', ')}</td>
                        <td>{booking.company}</td>
                        <td>{booking.contact_person_name}</td>
                        <td>{booking.contact_person_number}</td>
                        <td>{moment(booking.createdAt).format('DD MMM YYYY, hh:MM A')}</td>
                        <td>
                          <i
                            className='bx bxs-trash text-danger btn btn-sm'
                            onClick={() => {
                              setShowDelete({ status: true, data: booking._id });
                            }}
                          ></i>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      )}

      <div>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Login</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='mb-3'>
              <label className='mb-1'>Username</label>
              <input className='form-control' placeholder='Enter Username' value={username} onChange={(e) => setUsername(e.target.value)} />
            </div>
            <div>
              <label className='mb-1'>Password</label>
              <input className='form-control' placeholder='Enter Password' value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='primary' onClick={saveAuth}>
              Login
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

      <div>
        <Modal show={showDelete.status} onHide={handleCloseDelete}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Your Action</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='mb-3'>
              <span>Once a booking is deleted, the stalls will become available for to book. Please confirm your action.</span>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='danger' onClick={deleteBooking}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      {loading && <Preloader />}
    </div>
  );
}

export default AllBookingPage;
